/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Bidding_N_Battles__Answer_4Inputs */

const en_help_center__bidding_n_battles__answer_4 = /** @type {(inputs: Help_Center__Bidding_N_Battles__Answer_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes! You can join as many battles as you'd like simultaneously. Many experienced players participate in multiple battles to increase their winning chances.`)
};

/**
* | output |
* | --- |
* | "Yes! You can join as many battles as you'd like simultaneously. Many experienced players participate in multiple battles to increase their winning chances." |
*
* @param {Help_Center__Bidding_N_Battles__Answer_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__bidding_n_battles__answer_4 = /** @type {((inputs?: Help_Center__Bidding_N_Battles__Answer_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Bidding_N_Battles__Answer_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__bidding_n_battles__answer_4(inputs)
});